export const getNextMonth = (month) => {
  if (month === 12) return 1;
  return month + 1;
};
